import { VERIFICATION_STATUS } from '../constants';

// Define ordered array once
const STATUS_TABS = [
  VERIFICATION_STATUS.PENDING,
  VERIFICATION_STATUS.VERIFIED,
  VERIFICATION_STATUS.UPDATE_REQUESTED,
  VERIFICATION_STATUS.REJECTED
];

const getTabByStatus = (label: string): number => {
  return STATUS_TABS.indexOf(label);
};

const getStatusByTab = (tab: number): string => {
  return STATUS_TABS[tab] || VERIFICATION_STATUS.PENDING;
};

export { getTabByStatus, getStatusByTab };
